import log from 'loglevel';

// Actions
import getProductListByPLC from "../Action/GetProductList/getProductListByPLC";
import validateSerialNumber from '../Action/ValidateSerialNumber/validateSerialNumber';

// handlers
import handleSerialNumberValidation from './handleSerialNumberValidation';
import handleCrossGradeProducts from './handleCrossGradeProduct';

import { isEmpty } from '../util/util';

const handleSerialInputChange = async (e,
  currentHULADetails,
  dispatch,
  credentials,
  ) => {
  log.debug("./handler/handleSerialInputChange function called and value e =>", e);
  let serialNumberInput;
  if(typeof e === 'object'){ 
    // user is typing value, not choosing/available from dropdown.
    serialNumberInput = e.target.value;
  } else {
    // user choose value from the dropdown.
    serialNumberInput = e
  }
   
  dispatch({
    type: 'ENTER_SERIAL_NUMBER_ONLY',
    payload: serialNumberInput,
  });
  
  // NOTE : When datalist is empty and user enter serial number.
  if(currentHULADetails.datalist.length > 0 && currentHULADetails.datalist.includes(serialNumberInput)){
    log.debug('currentHULADetails.datalist(Array) : ', currentHULADetails.datalist)
    // eslint-disable-next-line no-lonely-if
    if(
        currentHULADetails.datalist instanceof Array && 
        currentHULADetails.datalist.includes(serialNumberInput)
      ) {
      log.debug('input value found from assets dropdown');
      const assets = serialNumberInput.split('     ');
      const sNumber = assets[0];
      const prodName = assets[1];
      log.debug('serial Number : ', sNumber, prodName);
      dispatch({
        type: 'ENTER_SERIAL_NUMBER_AND_PRODUCT',
        payload: {
          sNumber,
          prodName,
        },
      });

      const prodDetails = currentHULADetails.assets
      const data = prodDetails[sNumber][prodName];
      let productVersionList = [];
      data.release.forEach(release => {
        productVersionList.push(`${prodName} ${release}`)
      })
      try {
        const prodListPreviouesVersionEligible = await getProductListByPLC(data.plc, credentials);
        log.debug('Response from GetPreviousVersionProducts(AKA Crossgrade) : ', JSON.stringify(prodListPreviouesVersionEligible, 0, 2));
        const currentProductVersion = Math.max(...data.release.map(year => Number(year)))
        const { product:crossGradeProd } = prodListPreviouesVersionEligible.data; 
        
        let crossGrade;
        const crossGradeProduct = [];
        if(prodListPreviouesVersionEligible.data[0] !== null && prodListPreviouesVersionEligible.data.product[0] !== null) {
          crossGrade = crossGradeProd.filter((prd, i, element) => {
            const nextElement = element[i+1];
            if(prd.version === nextElement?.version 
              && prd.priorVersion === nextElement?.priorVersion 
              && prd.productName !== nextElement?.productName
              ){
                return false;
            } 
            return true;
          })
  
          // remove 'Autodesk' word from the product list. 
          crossGrade = crossGrade.map(prd => {
            const prodObject = prd;
            let { productName } = prodObject;
            productName = productName.replace('Autodesk ', '');
            prodObject.productName = productName
            return prodObject;
          })
          
          crossGrade.forEach(product => {
            if(Number(currentProductVersion) - Number(product.priorVersion) < 4 
              && Number(product.priorVersion < Number(currentProductVersion))){
              crossGradeProduct.push(`${product.productName} ${product.priorVersion}`)
  
              // Add product details into product mapping.
              if(!data.productKey[product.priorVersion]){
                data.productKey[product.priorVersion] = product.productKey;
              };
              if(!data.release.includes(product.priorVersion)){
                data.release.push(product.priorVersion);
              };
            }
          });
        }

        productVersionList = [...productVersionList, ...crossGradeProduct];
        productVersionList = productVersionList.sort();
        productVersionList = productVersionList.sort((a, b) => {
          if(Number(a.slice(-4)) > Number(b.slice(-4))){
            return -1;
          }
          return 1;
        })
        productVersionList = [...new Set(productVersionList)];
        productVersionList = productVersionList.filter(a => Number(a.slice(-4)) >= 2017);
        
        // log dispatch event!
        log.debug('DISPATCH (ADD_PRODUCT_LIST) with params -> ', {
          productVersions: productVersionList,
          productVersionKeys: data,     // take care this.
          isICAssets: true,
          showVersionDropdown: true,
        });

        dispatch({
          type: 'ADD_PRODUCT_LIST',
          payload: {
            productVersions: productVersionList,
            productVersionKeys: data,     // take care this.
            isICAssets: true,
            showVersionDropdown: true,
          },
        })
        // log.debug('Assets data : ', mapppedData);
      } catch (err){
        log.error('Error : ', err);
        dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
      }
    } else {
      dispatch({ type: 'CLEAR_PRODUCT_AND_VERSION_LIST' })
    }
  }
}

const handleSerialInputValidation = async (e, currentHULADetails, langStrings, errors, dispatch, credentials) => {
  // NOTE: ONLY call when user choose item from dropdown.
  log.debug('./handlers/handleSerialInputValidation function called! with value e : ', e);
  const {
    isMultiUserDeployment,
    isHULAEligible,
    hulsNotEligible,
    invalidSerialNumber,
    crossGradeHula,
    isTFLEX,
  } = errors;
  const hasValidationError = isMultiUserDeployment || 
    !isHULAEligible || 
    hulsNotEligible || 
    invalidSerialNumber ||
    crossGradeHula || 
    isTFLEX;
  log.debug('hasValidationError  > ', !hasValidationError)
  if(!hasValidationError && !isEmpty(e)) {
    if(currentHULADetails.datalist.includes(e)){
      handleSerialInputChange(e, currentHULADetails, dispatch, credentials)
    } else {
      const cleanValue = e.replace(/[^\d|-]/g, '');
      const { serialNumber } = currentHULADetails;
      if(cleanValue.length === 12 && !serialNumber) {
        log.debug('Serial Input value(string) : ', cleanValue);
        dispatch({
          type: 'SERIAL_NUMBER_VALIDATION',
          payload: cleanValue,
        })
        try {
          const response = await validateSerialNumber(cleanValue, credentials);
          log.debug('Response from Serial Number (ValidationAsset in router) ', JSON.stringify(response, 0, 2))
          if (response.status === 200) {
            // show dropdown for products based on response.
            const { assetType, colName } = response.data;
            const productMapping = {};
            const respFromSerialInput = handleSerialNumberValidation(response.data, dispatch, cleanValue, langStrings);
            log.debug('Response from ./handler/handleSerialNumberValidation : ', JSON.stringify(respFromSerialInput, 0, 2))
            if(!isEmpty(respFromSerialInput) && !isEmpty(respFromSerialInput.filteredProducts)){
              respFromSerialInput.filteredProducts.forEach(productDetails => {
                if(productDetails.release) {
                  let { productLineName } = productDetails;
                  productLineName = productLineName.replace('Autodesk ', '');
                  if(!productMapping[productLineName]) {
                    productMapping[productLineName] = [];
                  }
                }
              })

              respFromSerialInput.filteredProducts.forEach(productDetails => {
                if(productDetails.release) {
                  const { release } = productDetails;
                  let { productLineName } = productDetails;
                  productLineName = productLineName.replace('Autodesk ', '');
                  if(productMapping[productLineName]){
                    // productMapping[productLineName].push(`${productLineName} ${release}`)
                    productMapping[productLineName].push(`${productLineName} ${release}`);
                  }
                }
              })

              Object.keys(productMapping).forEach((product) => {
                productMapping[product] = [...new Set(productMapping[product])]
              })

              Object.keys(productMapping).forEach(key => {
                productMapping[key] = productMapping[key].sort();
              });
              log.debug("./handler/handleSerialInputValidation Product mapping value : ", productMapping);
              
              if(colName === '') {
                // NOTE: When colName property from ValidationAssets(router) call is empty!
                const productDetails = respFromSerialInput.filteredProducts;
                const PLC = productDetails[0].productLineCode;
                // eslint-disable-next-line eqeqeq
                const prodDetails = productDetails.filter( x => x.release == Math.max(...productDetails.map(y => y.release)))
                const currentVersion = prodDetails[0].release;
                await handleCrossGradeProducts(PLC, productDetails, currentVersion, dispatch, credentials);
              } else {
                const prodList = [...new Set(Object.keys(productMapping))].sort();
                log.debug('prod list :- ', prodList);
                dispatch({
                  type: 'STORE_PRODUCT_AND_VERSION',
                  payload: {
                    prodList,
                    productVersions: productMapping,
                    assetType: assetType === 'ICL',
                    productKeyMapping: respFromSerialInput.filteredProducts,
                    colName,
                    showProductDropdown: true,
                  },
                })
              }
            }
          } else {
            log.debug('Error in Router/ValidationAsset call status : ', JSON.stringify(response, 0, 2));
            dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
          }
        } catch (validationError) {
          log.debug('Serial Input Validation Error : ', validationError);
          dispatch({ type: 'GO_TO_ERROR_PAGE', payload: 'generalError' });
        }
      }
    }
  }
}

export {
  handleSerialInputChange,
  handleSerialInputValidation,
}
